export const MAXIMAL_INVOICE_NUMBER = 99999999
